(ns frontend.ui.component.settings.custom-field-modal
  (:require
   [frontend.ui.component.modal-dialog.view :as modal-dialog]
   [herb.core :as h]
   [frontend.ui.component.modal-dialog.style :as modal-style]
   [frontend.ui.component.form.view :as form]
   [ui.components.button.view :as button]
   [common.localization :as loc]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [common.util :as cu]
   [common.schema.field-type :as field-type]
   [frontend.ui.component.form.style :as form-style]
   [frontend.view.settings2.permissions.sub :as sub]
   [frontend.view.settings2.permissions.events :as events]
   [common.attribute :as attribute]
   ))


(defn create-dialog
  [{:keys [entity-type hide! status on-save! select! valid-field? similar-fields]
    :as   props}]
  (let [new-field @(rf/subscribe [::sub/new-field])
        set-value! (fn [attr value]
                     (rf/dispatch [::events/update-new-field attr value]))
        found-match? (boolean (some #{(cu/str-trim-lcase (get new-field :field/name))}
                                    (->> similar-fields
                                         (map (fn [[k fs]]
                                                (cu/str-trim-lcase (loc/field-name k fs))))
                                         (distinct)
                                         (remove cu/blank-value?))))]
    [modal-dialog/modal-dialog
     (assoc props
            :backdrop "static"
            :header-label (loc/tr :custom-field-create-header
                                  [(cu/str-trim-lcase (loc/tr entity-type))]))
     [:div
      {:class (h/<class modal-style/spacing-top-bottom)}
      [form/attribute-select
       :field/field-type
       (loc/tr :field/field-type)
       (get new-field :field/field-type)
       field-type/field-options
       set-value!]
      [form/attribute-input
       :field/name
       (loc/tr :field/name) (get new-field :field/name) (not (:field/field-type new-field)) set-value!]
      (when (seq similar-fields)
        [:label
         {:class (h/<class form-style/label)}
         (loc/tr :similar-fields)
         [:ul
          {:class (h/<class form-style/suggestion-list)}
          (->> similar-fields
               (map (fn [[k fs]]
                      [k (loc/field-name k fs)]))
               (sort-by (fn [[k l]]
                          (cu/str-trim-lcase l)))
               (map (fn [[k l]]
                      ^{:key (str "create-field-suggestion-" k)}
                      [:li
                       {:class    (h/<class (partial form-style/suggestion-list-item
                                                     (= (cu/str-trim-lcase (:field/name new-field))
                                                        (cu/str-trim-lcase l))))
                        :on-click (fn [_]
                                    (select! k))}
                       l]))
               (doall))]])
      #_[form/attribute-input :field/short-name state]
     ]
     [:div
      {:class (h/<class modal-style/footer-right)}
      [:div
       {:class (h/<class modal-style/spacing-left)}
       [button/secondary-hollow
        {:on-click (fn [_]
                     (hide!))}
        (loc/tr :cancel)]]
      [:div
       {:class (h/<class modal-style/spacing-left)}
       (cond
         (= status :status/processing)
         [button/secondary-open
          {:disabled? true}
          [:i.fal.fa-spinner.fa-pulse]]
         (valid-field? new-field)
         [button/primary-solid
          {:disabled? found-match?
           :on-click  (fn [_]
                        (on-save! new-field))}
          (loc/tr :create)]
         :else
         [button/primary-solid
          {:disabled? true}
          (loc/tr :create)])]]]))
